import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ModalComponentMediator } from "~app/common/components/modal/modal-component-mediator";
import { CommandService } from "~app/common/services/cqs/command.service";
import { EditKundorderradCommentCommand } from "../../commands/EditKundorderradCommentCommand";
import { KundorderService } from "../../kundorder.service";

export interface KundorderradCommentData {
    commentUpdatedCallback?: (comment: string) => void;
    editMode: boolean;
    kundorderradId: number;
}

@Component({
    selector: "rask-kundorderrad-comment",
    templateUrl: "./kundorderrad-comment.component.html",
    styleUrls: ["./kundorderrad-comment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextareaComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class KundorderradCommentComponent implements OnInit {
    comment: string;
    editMode: boolean;
    isEdited = false;
    kundorderradId: number;

    commentUpdatedCallback: (comment: string) => void;

    private readonly busyService = inject(BusyService);
    private readonly commandService = inject(CommandService);
    private readonly kundorderService = inject(KundorderService);
    private readonly modalComponentMediator = inject(ModalComponentMediator);

    @Input() set data(value: KundorderradCommentData) {
        this.kundorderradId = value.kundorderradId;
        this.commentUpdatedCallback = value.commentUpdatedCallback;
        this.editMode = value.editMode;
    }

    abort() {
        this.close();
    }

    changeComment(editedComment: string) {
        this.isEdited = true;
        this.comment = editedComment;
    }

    close() {
        this.modalComponentMediator.getRef().close(null);
    }

    ngOnInit(): void {
        this.loadComment();
    }

    save() {
        this.persistComment();
        if (this.commentUpdatedCallback) {
            this.commentUpdatedCallback(this.comment);
        }
        this.close();
    }

    private loadComment() {
        this.busyService.addWork(this.kundorderService.getKommentarForKundorderrad(this.kundorderradId)).subscribe(comment => {
            this.comment = comment;
        });
    }

    private persistComment() {
        const commandService = this.commandService.createInstance();
        const command = new EditKundorderradCommentCommand(this.kundorderradId, this.comment);
        commandService.addTransactionCommand(command);
        commandService.pushCommandQueueTransaction();
    }
}
